import Route from '@ember/routing/route';

export default class HotelSettingsPersonalRoute extends Route {}
